import { jsx as _jsx } from "react/jsx-runtime";
import { ContentType, GroupMouseover, GroupPreviewPage, GroupVodPreview, HomepageSectionType, Orientation, } from "../../types/global";
import { useGroupData, useGroupLook } from "../../stores/useGroupStore";
import React from "react";
import GenericSwiper from "../helpers/GenericSwiper";
import { checkContentLockedForUser, formatContentDuration, formatSchedulingDate, getContentPurchaseTypes, getContentRedirectUrl, } from "../../lib/utils";
import { useTranslation } from "react-i18next";
export default function SearchLayerSectionSwiper({ data, slideOrientation, className, onReachEnd, }) {
    const { t } = useTranslation();
    const groupLook = useGroupLook();
    const groupData = useGroupData();
    const mouseoverEnabled = groupLook?.look?.info.mouseover === GroupMouseover.Enabled;
    const previewEnabled = groupLook.look?.info.has_preview_vod_home == GroupVodPreview.Enabled;
    const intermediatePage = groupLook.look?.info.preview_page;
    const slides = data?.map((content) => {
        const contentObj = content;
        const image = contentObj.image
            ? JSON.parse(contentObj.image)
            : null;
        const flags = JSON.parse(contentObj.flags);
        const info = typeof contentObj.info === "string"
            ? JSON.parse(contentObj.info)
            : contentObj.info;
        const duration = info?.duration
            ? formatContentDuration(info?.duration, t)
            : null;
        const targetDate = formatSchedulingDate(info?.change_datetime, info?.change_timezone);
        const ageRestriction = info?.age_restriction ?? null;
        const locked = checkContentLockedForUser({ id: content.id, info: info }, groupData.data?.user_data, groupLook.look?.model_data);
        const purchaseTypes = getContentPurchaseTypes({ id: content.id, locked: locked, info: info }, groupData.data?.user_data, groupLook.look?.model_data);
        const redirectUrl = getContentRedirectUrl(locked, content, HomepageSectionType.News, slideOrientation, intermediatePage ?? GroupPreviewPage.Disabled);
        return {
            id: contentObj.id,
            contentType: ContentType.Video, // TEMPP
            contentContextType: ContentType.Video, // TEMPP
            title: contentObj.title,
            description: contentObj.description,
            redirectUrl: redirectUrl,
            image: image ?? undefined,
            flags: flags,
            orientation: slideOrientation,
            ageRestriction: ageRestriction,
            releaseDate: targetDate,
            duration: duration,
            purchaseTypes: purchaseTypes,
        };
    }) ?? [];
    const [hovered, setHovered] = React.useState(null);
    const setHoveredSlide = (index) => {
        setHovered(index);
    };
    return (_jsx("div", { className: `${className ?? ""} ${slideOrientation == Orientation.Landscape ? "" : "h-full min-h-0"} ${hovered !== null ? "z-50" : "z-10"} relative flex min-w-0 flex-col gap-3 select-none`, children: _jsx(GenericSwiper, { data: slides, swiperOrientation: Orientation.Landscape, slideOrientation: slideOrientation, slideConfig: {
                landscape: {
                    mouseOver: mouseoverEnabled,
                    mouseOverPreview: previewEnabled,
                    preview: previewEnabled,
                    dataLocation: "bottom",
                },
                portrait: {
                    mouseOver: mouseoverEnabled,
                    mouseOverPreview: previewEnabled,
                    preview: previewEnabled,
                },
            }, onHovered: setHoveredSlide, onReachEnd: onReachEnd }) }));
}
